<template>
  <div>
    <div class="jumbotron">
      <div class="mask org"></div>
      <b-row class="pt-5 text-left text-white" style="margin: auto;">
        
        <b-col cols="4" md="2" class="text-right">
          <b-img src="/iconss/organizzazioni.png" class="rounded-pill bg-white text-center p-2"></b-img>
        </b-col>
        
        <b-col cols="4" class="">
          <h2 style="color: white;">Benvenuto/a <i>{{this.user.first_name}}</i>!</h2>
          <p>Area riservata</p>
        </b-col>
      </b-row>
    </div>

    <div class="jumbotron" style="background-image: url(/img/bg-org.png);">
    <b-row class="row m-2 mx-auto d-flex justify-content-center" style="max-width: 80%;">

        <b-col class="mt-5 mr-3 ml-3">
          <div class="buttons avatar-box d-flex">
            <div class="buttons avatar my-auto">
              <b-img src="/iconss/translation.png"></b-img>
            </div>
            <div class="buttons black-box">
              <!-- <a href="/organization" style="color: orange;"><h4 class="text-center org_area">Richiedi una traduzione</h4></a> -->
              <b-button to="/organization" variant="link" style="color: orange;"><h3 class="text-center org_area">Richiedi una traduzione</h3></b-button>
            </div>
          </div>

          <div class="buttons avatar-box d-flex mt-5">
            <div class="buttons avatar my-auto">
              <b-img src="/iconss/communication.png"></b-img>
            </div>
            <div class="buttons black-box">
              <!-- <a href="/voice_to_voice" style="color: orange;"><h4 class="text-center org_area">Avvia una conversazione</h4></a> -->
              <b-button to="/voice_to_voice" variant="link" style="color: orange;"><h3 class="text-center org_area">Avvia una conversazione</h3></b-button>
            </div>
          </div>
        </b-col>

        <!-- <b-col class="mt-5 mr-3 ml-3">
          <div class="buttons avatar-box d-flex">
            <div class="buttons avatar my-auto">
              <b-img src="/iconss/communication.png"></b-img>
            </div>
            <div class="buttons black-box">
              <b-button to="/voice_to_voice" variant="link" style="color: orange;"><h3 class="text-center org_area">Avvia una conversazione</h3></b-button>
            </div>
          </div>
        </b-col> -->

        <b-col class="mt-5 mr-3 ml-3">
          <div class="buttons avatar-box d-flex">
            <div class="buttons avatar my-auto">
              <b-img src="/iconss/inbox.png"></b-img>
            </div>
            <div class="buttons black-box">
              <!-- <a href="/organizations/archivio" style="color: orange;"><h4 class="text-center org_area">Il mio<br>archivio</h4></a> -->
              <b-button to="/organizations/archivio" variant="link" style="color: orange;"><h3 class="text-center org_area">Il mio<br>archivio</h3></b-button>
            </div>
          </div>

          <div class="buttons avatar-box d-flex mt-5">
            <div class="buttons avatar my-auto">
              <b-img src="/iconss/group.png"></b-img>
            </div>
            <div class="buttons black-box">
              <b-button to="/translators" variant="link" style="color: orange;"><h3 class="text-center org_area">Trova un traduttore</h3></b-button>
            </div>
          </div>
        </b-col>

        <!-- <b-col class="mt-5 mr-3 ml-3">
          <div class="buttons avatar-box d-flex">
            <div class="buttons avatar my-auto">
              <b-img src="/iconss/group.png"></b-img>
            </div>
            <div class="buttons black-box">
              <b-button to="/translators" variant="link" style="color: orange;"><h3 class="text-center org_area">Trova un traduttore</h3></b-button>
            </div>
          </div>
        </b-col> -->

    </b-row>
    </div>

  </div>
</template>

<script>
import Util from "@/mixing/util";
import UserService from "@/services/user.service";

export default {
  mixins: [Util],
  computed: {
    document_typeState() {
      let n = this.document_type.length;
      return n < 20 ? null : false;
    },
  },
  data() {
    return {
      user: [],
    };
  },
  created() {
    
    UserService.whoAmI()
      .then((response) => (this.user = response.data))
      .catch((error) => {
        console.log("Whoami: error");
        console.log(error);
        this.$store.dispatch("auth/logout");
        this.$router.push("/login/organization");
      });
  },
  watch: {
  },
  methods: {
  },
};
</script>
<style>
.jumbotron {
  background-image: url("/img/bg-org.png");
}
.mask.org {
  background-color: #ff2300;
}
.butFile {
  border-radius: 0 25px 25px 0 !important;
  margin-left: -15px;
  z-index: 0;
  margin-bottom: 2px;
  height: 38px;
}
.btn-outline-primary,
.btn-outline-danger {
  z-index: 1;
}
.border-danger,
.btn-outline-secondary,
.btn-outline-primary,
.btn-outline-danger {
  border-width: 2px !important;
}
.buttons.avatar img{
  height: 60px!important;
}
.buttons.avatar-box .avatar {
  border: 5px solid #f49538;
}
.buttons.black-box {
  border: 5px solid #f49538;
}
</style>
